<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M13.3333 5.33398H6.66659C5.93021 5.33398 5.33325 5.93094 5.33325 6.66732V13.334C5.33325 14.0704 5.93021 14.6673 6.66659 14.6673H13.3333C14.0696 14.6673 14.6666 14.0704 14.6666 13.334V6.66732C14.6666 5.93094 14.0696 5.33398 13.3333 5.33398Z"
			:stroke="color"
			stroke-width="1.33333"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M2.66659 10.6673C1.93325 10.6673 1.33325 10.0673 1.33325 9.33398V2.66732C1.33325 1.93398 1.93325 1.33398 2.66659 1.33398H9.33325C10.0666 1.33398 10.6666 1.93398 10.6666 2.66732"
			:stroke="color"
			stroke-width="1.33333"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconCopyLink',
	props: {
		size: {
			type: [Number, String],
			default: 16
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	}
}
</script>
